export enum TypeQuestionEventsEnum {
    CREATEQUESTION = 'FORMULÁRIO',
    QUESTIONNAIRE = 'QUESTIONARIO',
    MEETING = 'REUNIÃO',
}

export enum TypeQuestionEventsIdEnum {
    'FORMULÁRIO' = 1,
    'QUESTIONARIO' = 2,
    'REUNIÃO' = 3,
}


